/* reducer is used in client area */
import {  USER_LOGOUT, FETCH_ALL_CONTRACTORS_LIST }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ALL_CONTRACTORS_LIST:
            console.log(FETCH_ALL_CONTRACTORS_LIST, action.payload);
            return {
                data: action.payload.data,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
